/*eslint max-lines-per-function: ["error", 220]*/
import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { FormSelect } from '../../../app/components/FormSelect';
import { CreateUpdateExamWithTestsDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { TakenCareOf } from '../../../common/spdCore/validation/schemas';
import HarmfulFactorMultiSelector from '../HarmfulFactor/HarmfulFactorMultiSelector';

import { HarmfulFactorsSupportingExaminationInfo } from './HarmfulFactorsSupportingExaminationInfo';

interface Props {
  prevStep?: () => void;
  nextStep?: () => void;
  handleFormData?: (
    input: string,
  ) => (e: string | boolean | Date | string[]) => void;
  referralFromEmployer?: boolean;
  areHarmfulFactors?: boolean;
  areResultsHarmfulFactors?: boolean;
  takenCareOf?: TakenCareOf;
  harmfulFactorsIds?: string[] | null;
  articleDoctorsIds?: string[] | null;
  articlePsychologistsIds?: string[] | null;
  propertyChange?: (obj: Partial<CreateUpdateExamWithTestsDto>) => void;
}

export const AddHarmfulFactory: React.FC<Props> = ({
  prevStep,
  nextStep,
  handleFormData,
  referralFromEmployer,
  areHarmfulFactors,
  areResultsHarmfulFactors,
  takenCareOf,
  harmfulFactorsIds,
  articleDoctorsIds,
  articlePsychologistsIds,
  propertyChange,
}) => {
  const handleOnNext = () => {
    if (nextStep) {
      nextStep();
    }
  };

  const handleOnPrev = () => {
    if (prevStep) {
      prevStep();
    }
  };
  const propertyChangeWithHandleFormData = (
    field: string,
    checked: boolean | string | Date | string[],
  ) => {
    if (handleFormData) {
      handleFormData(field)(checked);
    }
    if (propertyChange) {
      propertyChange({ [field]: checked });
    }
  };
  return (
    <>
      <Card>
        <Card.Body>
          <Card.Subtitle className="mb-4">Skierowanie</Card.Subtitle>
          <div className="d-grid gap-3">
            <FormRow
              controlId="referral_from_employer"
              label="Skierowanie od pracodawcy/placówki"
            >
              <Form.Check
                type="checkbox"
                checked={referralFromEmployer ? true : false}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'referralFromEmployer',
                    e.target.checked,
                  )
                }
              />
            </FormRow>
            <FormRow
              controlId="areHarmful_factors"
              label="Informacja o czynnikach szkodliwych"
            >
              <Form.Check
                type="checkbox"
                checked={areHarmfulFactors ? true : false}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'areHarmfulFactors',
                    e.target.checked,
                  )
                }
              />
            </FormRow>
            <FormRow
              controlId="are_results_harmful_factors"
              label="Wyniki pomiarów czynników szkodliwych"
            >
              <Form.Check
                type="checkbox"
                checked={areResultsHarmfulFactors ? true : false}
                onChange={e =>
                  propertyChangeWithHandleFormData(
                    'areResultsHarmfulFactors',
                    e.target.checked,
                  )
                }
              />
            </FormRow>
            <FormRow controlId="taken_care_of" label="Objęty opieką">
              <FormSelect
                value={takenCareOf}
                options={[
                  { value: 'Employee', label: 'Pracownik' },
                  { value: 'Outwork', label: 'Wykonujący pracę nakładczą' },
                  { value: 'Student', label: 'Pobierający naukę' },
                  { value: 'OwnRequest', label: 'Na własny wniosek' },
                ]}
                onChange={value =>
                  propertyChangeWithHandleFormData('takenCareOf', value)
                }
              />
            </FormRow>

            <HarmfulFactorMultiSelector
              selectedHarmfulFactor={harmfulFactorsIds || undefined}
              onChange={options =>
                propertyChangeWithHandleFormData(
                  'harmfulFactorsIds',
                  (options || [])?.map(o => o?.value),
                )
              }
            />
            <HarmfulFactorsSupportingExaminationInfo
              harmfulFactorsIds={harmfulFactorsIds}
              articleDoctorsIds={articleDoctorsIds}
              articlePsychologistsIds={articlePsychologistsIds}
            />
            {prevStep && nextStep && (
              <div className="d-flex justify-content-end m-3">
                <Button
                  variant="outline-secondary"
                  className="ms-1"
                  onClick={handleOnPrev}
                >
                  Wstecz
                </Button>

                <Button
                  variant="outline-primary"
                  className="ms-1"
                  onClick={handleOnNext}
                >
                  Dalej
                </Button>
              </div>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
